import {Suspense, useEffect} from 'react'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {saveReferrer} from './context/auth'
import {ThemeModeProvider} from '../_metronic/partials'

import { MenuComponent } from '../_metronic/assets/ts/components'

import { getAppName } from './utils'

import {TermsOfServiceModal} from './components/TermsOfServiceModal'
import { PrivacyPolicyModal } from './components/PrivacyPolicyModal'
import { AboutModal, notFirstTime } from './components/AboutModal'

import ReactGA from "react-ga4";

import {AuthInit} from './context/auth'

const GOOGLE_TRACKING_KEY = window.env?.REACT_APP_GOOGLE_TRACKING_KEY && window.env?.REACT_APP_GOOGLE_TRACKING_KEY != '' ? window.env?.REACT_APP_GOOGLE_TRACKING_KEY : null

if ( GOOGLE_TRACKING_KEY ){
  ReactGA.initialize(GOOGLE_TRACKING_KEY);
}

const App = () => {

	const location = useLocation()
  
  const navigate = useNavigate()

  const showAbout = location.hash === '#about'
  const showTermsOfService = location.hash === '#terms-of-service'
  const showPrivacyPolicy = location.hash === '#privacy-policy'

  const closeModal = () => {
    // showAbout && notFirstTime()
    navigate(window.location.pathname, { replace: true })
  }

	useEffect(() => {
		saveReferrer()
    document.title = getAppName()
	}, []);

	useEffect(() => {
		MenuComponent.reinitialization()
	}, [location.pathname])

  useEffect(() => {
		if( GOOGLE_TRACKING_KEY ){
			ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
		}
	}, [location]);


  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <ThemeModeProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
            {showTermsOfService && <TermsOfServiceModal show={showTermsOfService} handleClose={closeModal}/>}
            {showPrivacyPolicy && <PrivacyPolicyModal show={showPrivacyPolicy} handleClose={closeModal}/>}
            {showAbout && <AboutModal show={showAbout} handleClose={closeModal}/>}
          </AuthInit>
        </ThemeModeProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
